import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { PlaybookNodeData } from '../store/usePlaybookStore'; // Assuming common data structure

// Basic styling (can be enhanced later)
const nodeStyle: React.CSSProperties = {
  padding: '10px 15px',
  border: '1px solid #ff4500', // Orange border for debug
  borderRadius: '5px',
  background: '#fff0e6', // Light orange background
  fontSize: '12px',
  textAlign: 'center',
  minWidth: '120px',
};

const DebugNode: React.FC<NodeProps<PlaybookNodeData>> = ({ data }) => {
  return (
    <div style={nodeStyle}>
      {/* Input Handle (Top) */}
      <Handle type="target" position={Position.Top} id="input" />

      <div>
        <strong>Debug</strong>
        {data.label && <div>({data.label})</div>}
        {/* Display other relevant data if needed */}
      </div>

      {/* Output Handle (Bottom) - Debug nodes might pass data through */}
      <Handle type="source" position={Position.Bottom} id="output" />
    </div>
  );
};

export default memo(DebugNode);
